import { useCallback, useEffect, useState } from 'react'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/AdditionalServices/AdditionalServices.module.scss'
import { Footer } from '@src/components/Footer/Footer'
import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import { SubscribeBlock } from '@src/components/SubscribeBlock/SubscribeBlock'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { selectUserServices } from '@src/store/ducks/user/selectors'
import { AppDispatch } from '@src/store/store'
import {
  addDopService, getDopTariffs, removeDopService,
} from '@src/store/ducks/tariffs/thunks'
import {
  selectTariffsDopTariffs,
  selectTariffsIsLoading,
  selectTariffsIsLoadingChangeTariff, selectTariffsIsSuccessChangeTariff,
} from '@src/store/ducks/tariffs/selectors'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { resetTariffs, setIsSuccessChangeTariff } from '@src/store/ducks/tariffs/reducer'
import { Modal } from '@src/components/common/Modal/Modal'
import { Button } from '@src/components/Button/Button'
import { DopTariff } from '@src/store/ducks/tariffs/types'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import { setPageTitle } from '@src/store/ducks/app/reducer'

export const AdditionalServices = () => {
  const params = useParams<{ serviceId: string }>()
  const dispatch = useDispatch<AppDispatch>()
  const services = useSelector(selectUserServices)
  const dopTariffs = useSelector(selectTariffsDopTariffs)
  const isLoading = useSelector(selectTariffsIsLoading)
  const isLoadingChangeTariff = useSelector(selectTariffsIsLoadingChangeTariff)
  const isSuccessChangeTariff = useSelector(selectTariffsIsSuccessChangeTariff)
  const [select, setSelect] = useState<DopTariff | null>(null)

  useEffect(() => {
    dispatch(setPageTitle('Дополнительные услуги | Личный кабинет для абонентов КОСМОС Телеком'))
  }, [dispatch])

  useEffect(() => {
    if (services.tariff) {
      dispatch(getDopTariffs(+params.serviceId))
    }
  }, [dispatch, params.serviceId, services.tariff])

  useEffect(() => () => {
    dispatch(resetTariffs())
  }, [dispatch])

  const handleChange = useCallback(() => {
    if (select) {
      if (select.isActive) {
        dispatch(removeDopService(select.serviceId))
      } else {
        dispatch(addDopService(select.goodId, +params.serviceId))
      }
    }
  }, [dispatch, params.serviceId, select])

  const closeModal = useCallback(() => {
    setSelect(null)
    dispatch(setIsSuccessChangeTariff(false))
  }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.tariffContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <h1 className={style.mainTitle}>Дополнительные услуги</h1>
        <Preloader loading={isLoading} center>
          <div className={style.additionalContainer}>
            {!dopTariffs.length && (
              <div>Данный тариф не предусматривает дополнительных услуг</div>
            )}
            {dopTariffs.map((tariff) => (
              <SubscribeBlock
                title={(
                  <div>
                    {tariff.goodName}
                    {tariff.isConnects && (tariff.isActive ? (
                      <span className={style.startDate}>
                        (действует до
                        {' '}
                        {moment(tariff.dateEnd, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                        )
                      </span>
                    ) : (
                      <span className={style.startDate}>
                        (действует с
                        {' '}
                        {moment(tariff.dateStart, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                        )
                      </span>
                    ))}
                  </div>
                )}
                cost={tariff.price}
                btn
                btnName={tariff.isActive ? 'Отключить' : 'Подключить'}
                btnType={tariff.isActive ? 'secondary' : 'primary'}
                btnOutline={tariff.isActive}
                btnLoading={tariff.isConnects}
                key={tariff.goodId}
                btnClick={() => { setSelect(tariff) }}
              />
            ))}
          </div>
        </Preloader>
      </div>
      <Footer />
      <Modal isOpen={!!select} close={closeModal}>
        {isSuccessChangeTariff ? (
          <>
            <div className={style.confirmActions}>
              Ваше изменения были
              <span className="blue"> успешно сохранены</span>
              {' '}
              и активированы!
            </div>
          </>
        ) : (
          <>
            <div className={style.confirmActions}>
              Подтвердите Ваше действие по изменениям
            </div>
            <div className={style.actions}>
              {select && (
                <Button
                  className={style.btnSize}
                  loading={isLoadingChangeTariff}
                  onClickFunc={() => handleChange()}
                >
                  Подтвердить
                </Button>
              )}
              <Button
                className={style.btnSize}
                disabled={isLoadingChangeTariff}
                type="textSecondary"
                onClickFunc={() => setSelect(null)}
              >
                Отменить
              </Button>
            </div>
          </>
        )}
      </Modal>
    </div>
  )
}
